import { render, staticRenderFns } from "./VisitaAngiologicaEdit.vue?vue&type=template&id=4c3e181f&scoped=true"
import script from "./VisitaAngiologicaEdit.vue?vue&type=script&lang=js"
export * from "./VisitaAngiologicaEdit.vue?vue&type=script&lang=js"
import style0 from "./VisitaAngiologicaEdit.vue?vue&type=style&index=0&id=4c3e181f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3e181f",
  null
  
)

export default component.exports